import * as actions from '../actions/actionTypes';

const initialState = {
  id: null,
  data: [],
  employees: [],
  dissmissList: [],
};

const fetchEmployeeSuccess = (state, action) => ({ ...state, data: action.data });

const updateEmployeeSuccess = (state, action) => ({ ...state, data: action.data });

const createEmployeeSucess = state => ({ ...state });

const fetchEmployeesSuccess = (state, action) => ({ ...state, employees: action.employees });

const fetchDissmissEmployeeSuccess = (state, action) => ({ ...state, dissmissList: action.data });

const deleteEmployeeSuccess = (state, action) => {
  const newEmployees = state.employees.filter(employee => employee.id !== action.id);
  return {
    ...state,
    employees: newEmployees,
  };
};

const applyRestrictionsSuccess = (state, action) => {
  const newEmployees = state.employees.map((employee) => {
    for (let index = 0; index < action.restrictions.length; index += 1) {
      if (employee.id === action.restrictions[index].employeeId) {
        return {
          ...employee,
          _hasPhoto: action.restrictions[index].hasPhoto,
          _restrictByLocation: action.restrictions[index].restrictByLocation,
          _workingDay: action.restrictions[index].workingDay.description,
          _workingDayId: action.restrictions[index].workingDayId,
          _dtRef: action.restrictions[index].dtRef,
          locations: action.restrictions[index].locations,
        };
      }
    }
    return employee;
  });

  return {
    ...state,
    employees: newEmployees,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EMPLOYEE_SUCCESS: return fetchEmployeeSuccess(state, action);
    case actions.UPDATE_EMPLOYEE_SUCCESS: return updateEmployeeSuccess(state, action);
    case actions.CREATE_EMPLOYEE_SUCCESS: return createEmployeeSucess(state, action);
    case actions.FETCH_EMPLOYEES_SUCCESS: return fetchEmployeesSuccess(state, action);
    case actions.DELETE_EMPLOYEE_SUCCESS: return deleteEmployeeSuccess(state, action);
    case actions.APPLY_RESTRICTIONS_SUCCESS: return applyRestrictionsSuccess(state, action);
    case actions.FETCH_DISMISS_EMPLOYEE_SUCCESS: return fetchDissmissEmployeeSuccess(state, action);

    default: return state;
  }
};

export default reducer;
